<div class="container">
    <article *ngFor="let content of data?.content">
        <app-spot-headline *ngIf="content.headlineText" [index]="data.spotIndex">
            {{ content.headlineText }}
        </app-spot-headline>
        <div
            *ngIf="content.richText"
            class="kk-rte"
            appInterceptLinks
            [innerHTML]="content.richText | safe: 'html'"
        ></div>
    </article>
</div>
